import { orderIsFreeShippingEligible } from "../../utils/orderIsFreeShippingEligible";
import { ViewOrderInvoiceCTA } from "./ctas";
export var DidNotGetInsiderFreeShippingIA = function DidNotGetInsiderFreeShippingIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_IS_FREE_SHIPPING_INELIGIBLE(strictLocalize);
  }
  var isFreeShippingEligible = orderIsFreeShippingEligible(brandOrder);
  if (!isFreeShippingEligible) {
    return ORDER_IS_FREE_SHIPPING_INELIGIBLE(strictLocalize);
  }
  return ORDER_IS_FREE_SHIPPING_ELIGIBLE(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return undefined;
  }
  var isFreeShippingEligible = orderIsFreeShippingEligible(brandOrder);
  if (!isFreeShippingEligible) {
    return undefined;
  }
  return ViewOrderInvoiceCTA(strictLocalize, brandOrder);
};
var ORDER_IS_FREE_SHIPPING_INELIGIBLE = function ORDER_IS_FREE_SHIPPING_INELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHY_I_DID_NOT_RECEIVE_INSIDER_FREE_SHIPPING(strictLocalize);
    },
    getDescription: function getDescription() {
      return [INSIDER_OFFERS_FREE_SHIPPING_WITH_SELECT_BRANDS(strictLocalize)];
    }
  };
};
var ORDER_IS_FREE_SHIPPING_ELIGIBLE = function ORDER_IS_FREE_SHIPPING_ELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHY_I_DID_NOT_RECEIVE_INSIDER_FREE_SHIPPING(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_SHOULD_QUALIFY_FOR_INSIDER_FREE_SHIPPING(strictLocalize)];
    }
  };
};
var WHY_I_DID_NOT_RECEIVE_INSIDER_FREE_SHIPPING = function WHY_I_DID_NOT_RECEIVE_INSIDER_FREE_SHIPPING(strictLocalize) {
  return strictLocalize({
    id: "AFUJpc",
    defaultMessage: [{
      "type": 0,
      "value": "Waarom heb ik geen gratis verzending met Insider gekregen voor mijn bestelling?"
    }]
  });
};
var INSIDER_OFFERS_FREE_SHIPPING_WITH_SELECT_BRANDS = function INSIDER_OFFERS_FREE_SHIPPING_WITH_SELECT_BRANDS(strictLocalize) {
  return strictLocalize({
    id: "n75Vyn",
    defaultMessage: [{
      "type": 0,
      "value": "Het is belangrijk om op te merken dat je Insider-lidmaatschap gratis verzending biedt bij bepaalde merken. Hoewel dit voordeel niet van toepassing is op de hele marktplaats, kun je tijdens het rondkijken op Faire makkelijk zien welke merken in aanmerking komen. Zoek naar merken die zijn gemarkeerd met ‘Gratis verzending met Insider’, samen met een blauw sleutelsymbool. Als je Insider-lidmaatschap de verzendkosten voor een bepaald merk dekt, wordt dit bovendien aangegeven bij het afrekenen. Als een merk niet wordt gedekt, worden de verzendkosten weergegeven als ‘TBD’ of worden geschatte verzendkosten opgegeven."
    }]
  });
};
var ORDER_SHOULD_QUALIFY_FOR_INSIDER_FREE_SHIPPING = function ORDER_SHOULD_QUALIFY_FOR_INSIDER_FREE_SHIPPING(strictLocalize) {
  return strictLocalize({
    id: "HkpAbF",
    defaultMessage: [{
      "type": 0,
      "value": "De bestelling die je hebt geselecteerd komt in aanmerking voor gratis verzending met Insider. Om te bevestigen of gratis verzending met Insider is toegepast op deze bestelling, ga je naar het tabblad ‘Facturen’ in je Faire-portaal en zoek je de bijbehorende factuur. Kijk naar de regel verzendkosten, waar de toepassing van gratis verzending met Insider op deze bestelling duidelijk zichtbaar moet zijn. Als je dit niet ziet, kun je contact opnemen met ons supportteam voor extra hulp."
    }]
  });
};